export const WidgetsList = [
  {
    label: "Stock",
    icon: "icon-head-stock.svg",
    class: "stock",
    children: [
      { label: "People & Key People", value: "TraderverseStockPeopleKey" },
      { label: "Upgrades & Downgrades", value: "TraderverseUpgradesDowngrades" },
      { label: "Seasonality", value: "TraderverseSeasonality" },
      { label: "Asset Specific Price Target Consensus", value: "TraderverseStockAssetSpecificPriceTargetConsensus" },
      { label: "Earning", value: "TraderverseEarning" },
      { label: "Price Performance", value: "TraderversePricePerformance" },
      { label: "Asset Specific Upgrades and Downgrades", value: "TraderverseStockAssetSpecificUpgradesDowngrades" },
      { label: "Candlestick Chart", value: "TraderverseCandleStickChartKline" },
      { label: "Asset Specific Congress Trading Flow", value: "TraderverseStockAssetSpecificCongressTradingFlow" },
      { label: "Company Detail", value: "TraderverseCompanyStockDetail" },
      { label: "Share Structure", value: "TraderverseShareStructure" },
      { label: "Statements", value: "TraderverseStockDetailFundanmental" },
      { label: "Stocks Specific Insider Trading Flow", value: "TraderverseStocksSpecificInsiderTradingFlow" },
      { label: "Short Flow", value: "TraderverseShortVolume" },
      { label: "Price Camparison", value: "TraderversePriceCamparison" },
      { label: "Price Ratio", value: "TraderversePriceRatio" },
      { label: "Asset Specific News and Press Release", value: "TraderverseStockAssetSpecificNewsPressRelease" },
      { label: "Asset Specific Analyst Price Target", value: "TraderverseStockAssetSpecificAnalystPriceTarget" },
      { label: "Fundamental", value: "TraderverseFinancialFundamental" },
      { label: "Key Metrics", value: "TraderverseKeyMetrics" },
      { label: "Instituional Flow", value: "TraderverseInstituionalFlow" },
      { label: "Financial Summary", value: "TraderverseStockFinancial" },
      { label: "Overview Top Highlights", value: "TraderverseStockOverview" },
      { label: "Highlights", value: "TraderverseOverviewTopHighlights" },
    ],
  },
  {
    label: "Equity Market",
    icon: "icon-head-market.svg",
    class: "market",
    children: [
      { label: "Latest News", value: "TraderverseMarketNews" },
      { label: "Market Leaders", value: "TraderverseMarketLeaders" },
      { label: "Treasury Rates", value: "TraderverseTreasuryRates" },
      { label: "Upcoming Earnings", value: "TraderverseUpComingEarning" },
      { label: "Top Movers", value: "TraderverseTopMovers" },
      { label: "Top Index", value: "TraderverseTopIndex" },
      { label: "Economic Calendar", value: "TraderverseMarketEconomicCalendar" },
      { label: "Market Heatmap", value: "TraderverseMarketHeatMap" },
      { label: "Sector Performance", value: "TraderverseMarketSectorPerformance" },
      { label: "Sector Rotation Line Chart", value: "TraderverseSectorRotation" },
      { label: "Sector Correlation", value: "TraderverseMarketSectorCorrelation" },
      { label: "Symbol Briefing", value: "TraderverseMarketingBreif" },
      { label: "Market Wide Insider Activity Flow", value: "TraderverseMarketWideInsiderActivityFlow" },
      { label: "Historical Treasury Rates", value: "TraderverseHistoricalTreasuryRates" },
      { label: "High Yield Dividend", value: "TraderverseHighYieldDividend" },
      { label: "Dividend Payment Timeline ", value: "TraderverseDividendPaymentTimeline" },
      { label: "Current Grade Distribution Grid ", value: "TraderverseMarketCurrentGradeDistributionGrid" },
      { label: "Bull vs Bear Target Meter ", value: "TraderverseBullvsBearTargetMeter" },
      { label: "IPO Price Distribution", value: "TraderverseIPOPriceDistribution" },
      { label: "IPO Timeline Calendar", value: "TraderverseIPOTimelineCalendar" },
      { label: "Treasury Yield Curve", value: "TraderverseTreasuryYieldCurve" },
      { label: "Rating Action Momentum Tracker", value: "TraderverseRatingActionMomentumTracker" },
      { label: "Biggest Losers", value: "TraderverseBiggestlosers" },
      { label: "Biggest Gainers", value: "TraderverseBiggestGainers" },
      { label: "Most Active Stock", value: "TraderverseMostActiveStock" },
      { label: "Price Target Consensus Dashboard", value: "TraderversePriceTargetConsensusDashboard" },
      { label: "Stock Splits", value: "TraderverseStockSplits" },
      { label: "Winners / Losers Exchange", value: "TraderverseWinnersLosersExchange" },
      { label: "Valuation Gauge Dashboard", value: "TraderverseValuationGaugeDashboard" },
      { label: "Congress Trading Market  Wide", value: "TraderverseCongressTradingMarketWide" },
      { label: "Market Pulse", value: "TraderverseMarketPulse" },
      { label: "Analyst Price Targets Market Wide", value: "TraderverseAnalystPriceTargetsTable" },
      { label: "Upgrades & Downgrades Market Wide", value: "TraderverseAllSymbolsUpgradesDowngrades" },
      { label: "Insider Buy/Sell Momentum Timeline ", value: "TraderverseInsiderBuySellMomentumTimeline" },
      { label: "Price Target Gap Visualizer", value: "TraderversePriceTargetGapVisualizer" },
      { label: "Dividend Yield Heatmap", value: "TraderverseMarketDividendYieldHeatmap" },
      { label: "Sector Valuation Heatmap", value: "TraderverseMarketSectorValuationHeatmap" },
      { label: "Relative Valuation Bar Chart", value: "TraderverseRelativeValuationBarChart" },
      { label: "P/E Trend Sparklines", value: "TraderverseMarketPETrendSparklines" },
      { label: "Winners / Losers Market Cap", value: "TraderverseMarketWinLossMarketCap" },
      { label: "IPO Deal Size Bubble", value: "TraderverseIPODealSizeBubble" },
      { label: "Yield Distribution Analyzer", value: "TraderverseYieldDistributionAnalyzer" },
      { label: "Winners / Losers by Sector", value: "TraderverseMarketWinLossSector" },
      { label: "Recent Insider Transactions", value: "TraderverseMarketRecentInsiderTransactions" },
      { label: "Financial Statements", value: "TraderverseFinancialStatements" },
      { label: "Analyst Price Targets", value: "TraderverseMarketAnalystPriceTargetMarketWide" },
      { label: "Events Calendar", value: "TraderverseCryptoEventsCalendar" },
      { label: "Exchange Cards", value: "TraderverseMarketExchangeCards" },
      { label: "Stocks In Most Fund", value: "TraderverseStocksInMostFund" },
      { label: "Number of Acquisitions per Sector", value: "TraderverseNumberOfAcquisitionsPerSector" },
      { label: "House Trade Types", value: "TraderverseHouseTradeTypes" },

    ],
  },
  {
    label: "Crypto",
    icon: "icon-head-crypto.svg",
    class: "crypto",
    children: [
      { label: "Breakdown By Country", value: "TraderverseCryptoBreakDownByCountry" },
      { label: "Countries Breakdown", value: "TraderverseBreakdownCountry" },
      { label: "Bitcoin Dominance Chart", value: "TraderverseCryptoBitcoinDominanceChart" },
      { label: "Bitcoin Dominance", value: "TraderverseCryptoBitcoinDominance" },
      { label: "Airdrops", value: "TraderverseCryptoAirdrops" },
      { label: "Company", value: "TraderverseCryptoCompany" },
      { label: "Market Cap", value: "TraderverseCryptoMarketCap" },
      { label: "Market Cap Chart", value: "TraderverseCryptoMarketCapChart" },
      { label: "Market Chart", value: "TraderverseCryptoMarketChartBreakdown" },
      { label: "Spot Chart (24h)", value: "TraderverseCryptoSpotChart" },
      { label: "Top Movers", value: "TraderverseCryptoTopMovers" },
      { label: "Fear And Greed Index", value: "TraderverseFearAndGreed" },
      { label: "Fear And Greed Index Chart", value: "TraderverseFearAndGreedChart" },
      { label: "CEX Spot Volume Chart", value: "TraderverseSpotVolumeChart" },
      { label: "Trending Coins", value: "TraderverseTrendingCoins" },
      { label: "Top Market Crypto", value: "TraderverseCryptoLiveCard" },
      { label: "Company Detail", value: "TraderverseCryptoCompanyDetail" },
      { label: "Highlights", value: "TraderverseCryptoHighlightsSection" },
      { label: "Overview Top Highlights", value: "TraderverseCryptoOverviewTopHighlights" },
    ],
  },
  {
    label: "News",
    icon: "icon-head-news.svg",
    class: "news",
    children: [
      { label: "News Sentiments", value: "TraderverseTopNews" },
      { label: "Sentiment Volume", value: "TraderverseHomeSentimentVolume" },
      { label: "Index", value: "TraderverseNewsHomeIndex" },
      { label: "Bias Distribution", value: "TraderverseBiasDistribution" },
      { label: "Sources", value: "TraderverseNewsSource" },
      { label: "News Articles by Source", value: "TraderverseAIAnalysisArticlesBySource" },
      { label: "Sentiment Score Distribution", value: "TraderverseAIAnalysisScoreDistribution" },
      { label: "Average Sentiment by Time of Day", value: "TraderverseNewsAverageSentiment" },
      { label: "Source Reliability", value: "TraderverseSourceReliability" },
      { label: "Daily Sentiment Volume and Average ", value: "TraderversenewsSentimentVolumeDaily" },
      { label: "News Volume Average Sentiment", value: "TraderverseNewsVolumeAverageSentiment" },
      { label: "News Weighted Sentiment Impact", value: "TraderverseNewsWeightedSentimentImpactHigh" },
      { label: "Top 10 Symbols by Average Sentiment Score", value: "TraderverseNewsSymbolByAverage" },
      { label: "SPY Price and Average Sentiment by Category", value: "TraderverseNewsAverageSentimentByCatagory" },
      { label: "S&P 500 Price and Average Daily Sentiment", value: "TraderverseSPYPriceAverage" },
      { label: "Sentiment Trend Over Time for Top 5 Symbols", value: "TraderverseSentimentTrendOverTime" },
      { label: "News Clusters", value: "TraderverseHomeNewsClusters" },
      { label: "Must Read", value: "TraderverseNewsMustRead" },
      { label: "Market News", value: "TraderverseHomeForexNews" },
      { label: "Popular Official Publishers", value: "TraderversePopularPublishers" },
      { label: "Latest Press Releases", value: "TraderverseLatestPressRelease" },
      { label: "Symbol Summary", value: "TraderverseStockSummary" },
      { label: "News Clusters", value: "TraderverseClustersNewsClusters" },
      { label: "Latest News", value: "TraderverseMarketNewsSymbolSpecific" },
    ],
  },
];